module.exports = "/_next/static/images/fd005cbc0b5a0cab6c4bd41c5ab17c70-icon-monthly-payments.svg.webp";